import sanitizeHtml from 'sanitize-html'

export const stripHTML = (originalString: string) => sanitizeHtml(originalString, { allowedTags: [] })
